"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyledMenuItemColorByHeaderType = exports.getFillByHeaderType = exports.getBgColorByHeaderType = exports.getActiveBgColorByHeaderType = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _Header = require("../Header/Header");

var getBgColorByHeaderType = function getBgColorByHeaderType(theme, type) {
  var _bgColorMap;

  var bgColorMap = (_bgColorMap = {}, (0, _defineProperty2["default"])(_bgColorMap, _Header.B2B, theme.palette.common.white), (0, _defineProperty2["default"])(_bgColorMap, _Header.CUSTOM, theme.palette.common.white), (0, _defineProperty2["default"])(_bgColorMap, _Header.DTC, theme.palette.common.white), (0, _defineProperty2["default"])(_bgColorMap, _Header.MARKETING, theme.palette.primary.main), _bgColorMap);
  return bgColorMap[type];
};

exports.getBgColorByHeaderType = getBgColorByHeaderType;

var getFillByHeaderType = function getFillByHeaderType(theme, type) {
  var _fillMap;

  var fillMap = (_fillMap = {}, (0, _defineProperty2["default"])(_fillMap, _Header.B2B, theme.palette.primary.main), (0, _defineProperty2["default"])(_fillMap, _Header.CUSTOM, 'rgba(0, 0, 0, 0.2)'), (0, _defineProperty2["default"])(_fillMap, _Header.DTC, theme.palette.primary.main), (0, _defineProperty2["default"])(_fillMap, _Header.MARKETING, 'rgba(255, 255, 255, 0.8)'), _fillMap);
  return fillMap[type];
};

exports.getFillByHeaderType = getFillByHeaderType;

var getActiveBgColorByHeaderType = function getActiveBgColorByHeaderType(theme, type) {
  var _bgColorMap2;

  var bgColorMap = (_bgColorMap2 = {}, (0, _defineProperty2["default"])(_bgColorMap2, _Header.B2B, (0, _colorManipulator.alpha)(theme.palette.primary.main, 0.15)), (0, _defineProperty2["default"])(_bgColorMap2, _Header.CUSTOM, (0, _colorManipulator.alpha)(theme.palette.primary.main, 0.15)), (0, _defineProperty2["default"])(_bgColorMap2, _Header.DTC, (0, _colorManipulator.alpha)(theme.palette.primary.main, 0.15)), (0, _defineProperty2["default"])(_bgColorMap2, _Header.MARKETING, theme.palette.primary.dark), _bgColorMap2);
  return bgColorMap[type];
};

exports.getActiveBgColorByHeaderType = getActiveBgColorByHeaderType;

var getStyledMenuItemColorByHeaderType = function getStyledMenuItemColorByHeaderType(theme, type) {
  var _fontColorMap;

  var fontColorMap = (_fontColorMap = {}, (0, _defineProperty2["default"])(_fontColorMap, _Header.B2B, theme.typography.body1.color), (0, _defineProperty2["default"])(_fontColorMap, _Header.CUSTOM, theme.typography.body1.color), (0, _defineProperty2["default"])(_fontColorMap, _Header.DTC, theme.typography.body1.color), (0, _defineProperty2["default"])(_fontColorMap, _Header.MARKETING, theme.palette.primary.main), _fontColorMap);
  return fontColorMap[type];
};

exports.getStyledMenuItemColorByHeaderType = getStyledMenuItemColorByHeaderType;